import { render, staticRenderFns } from "./System_Welfare.vue?vue&type=template&id=029ea8a7&scoped=true&"
import script from "./System_Welfare.vue?vue&type=script&lang=js&"
export * from "./System_Welfare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029ea8a7",
  null
  
)

export default component.exports